import React from 'react'

export type TicketDisplayContextType =
  | {
      type: 'account-activity' | 'race-card'
      data?: never
    }
  | {
      type: 'share'
      data: {
        shouldHideCost: boolean
        display: 'external-share' | 'betloop-quick-share' | 'bet-loop'
        /** Used for quick sharing to Bet Loop */
        isSelected?: boolean
        forcedStatus?: 'pending' | 'resulted'
      }
    }
  | {
      type: 'pending-bets-drawer'
      data: { isSkyRaceMatch: boolean }
    }

/** Handles different display variations for Ticket child components
 *  @default type: 'account-activity' */
export const TicketDisplayContext = React.createContext<TicketDisplayContextType>({
  type: 'account-activity',
})
